import apiClient from "../api/setup";
import { ManagedUser, Tema } from "../types/general";
import { DataPagened } from "../types/utils";

export interface NewUserData {
  name: string;
  email_whatsapp: string;
  phone?: string;
  address?: string;
}

// Operações de administração de utilizadores e da sua associação a temas.
// Os erros são propagados para o viewmodel os mostrar.
function useUsersModel() {
  const fetchUsers = async (page = 1): Promise<DataPagened<ManagedUser> & { totalData: number }> => {
    const { data } = await apiClient.get("/api/user/admin/users", { params: { page } });
    return {
      data: data.data,
      pagination: data.pagination,
      totalData: data.pagination.totalData ?? 0,
    };
  };

  const fetchUser = async (id: number): Promise<ManagedUser> => {
    const { data } = await apiClient.get(`/api/user/admin/users/${id}`);
    return data;
  };

  const createUser = async (user: NewUserData): Promise<ManagedUser> => {
    const { data } = await apiClient.post("/api/user/admin/users", user);
    return data;
  };

  const deleteUser = async (id: number) => {
    await apiClient.delete(`/api/user/admin/users/${id}`);
  };

  // A listagem de temas é paginada; percorre todas as páginas
  const fetchAllTemas = async (): Promise<Tema[]> => {
    const temas: Tema[] = [];
    let page = 1;
    let totalPages = 1;
    do {
      const { data } = await apiClient.get("/api/temas", { params: { page, all: "true" } });
      temas.push(...data.data);
      totalPages = data.pagination.totalPages;
      page += 1;
    } while (page <= totalPages);
    return temas;
  };

  const associateTema = async (userId: number, temaId: number) => {
    await apiClient.post(`/api/temas/${temaId}/users/${userId}`);
  };

  const disassociateTema = async (userId: number, temaId: number) => {
    await apiClient.delete(`/api/temas/${temaId}/users/${userId}`);
  };

  return { fetchUsers, fetchUser, createUser, deleteUser, fetchAllTemas, associateTema, disassociateTema };
}

export default useUsersModel;
